import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";
export class DeleteLeverantorsorderradCommand extends BasicCommand<DeleteLeverantorsorderradCommand> {
    primaryKey: import("~app/common/services/cqs/IPrimaryKey").IPrimaryKey<DeleteLeverantorsorderradCommand>;
    leverantorsorderradId: number;
    leverantorsorderId: number;
    constructor(leverantorsorderradId: number, leverantorsorderId: number) {
        super("DeleteLeverantorsorderradCommand", "leverantorsorderrad", CommandType.Delete);
        this.leverantorsorderradId = leverantorsorderradId;
        this.leverantorsorderId = leverantorsorderId;
    }
}
